import React from 'react';

import {useRowItemContext} from '../RowItemContext';
import {RowItemChevronView} from './RowItemChevron.styles';
import {ChevronLargeRightIcon} from '../../../icons';

import type {RowItemChevronProps} from './_types';

export const RowItemChevron = React.forwardRef<
  HTMLDivElement,
  RowItemChevronProps
>(({shouldHideOnActive, dragState, isDisabled}, ref) => {
  const {itemProps} = useRowItemContext();
  const {colorVariant, textColorVariant} = itemProps;

  const iconColor = textColorVariant ?? colorVariant;

  return (
    <RowItemChevronView
      dragState={dragState}
      isDisabled={isDisabled}
      ref={ref}
      shouldHideOnActive={shouldHideOnActive}
    >
      <ChevronLargeRightIcon colorVariant={iconColor ?? 'default'} />
    </RowItemChevronView>
  );
});

RowItemChevron.displayName = 'RowItemChevron';
RowItemChevron.toString = RowItemChevronView.toString;
